module.exports = __webpack_public_path__ + "static/media/header_image_04.8f5c4f40.jpg";